import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { isInIframe } from 'utils';
import { NewDashboardBannerUI } from './ui';

export class NewDashboardBanner extends PureComponent {
    static displayName = 'NewDashboardBannerContainer';

    render() {
        // Always shown, signed in or out, but never inside embeds
        return isInIframe() ? null : <NewDashboardBannerUI />;
    }
}

export const NewDashboardBannerContainer = compose()(NewDashboardBanner);
